module.exports = __webpack_public_path__ + "media/images/talent/case04-badge-0002056e9302bfa27d08a0e4a1086083.png";